







import Vue from 'vue'

import Default from '@/layout/Default.vue'

export default Vue.extend({
  name: 'NotFound',
  components: {
    Default
  }
});
